import React from 'react'

export default class Button extends React.Component {
  render () {
    const {text, ...rest} = this.props
    return (
      <a {...rest} target='_blank' rel='noopener'
        className={`button has-text-white has-text-weight-bold ${this.props.className}`}>
        {text}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/button.js